import React from 'react';

import { Section, Grid } from '@gogame/components';
import { withArrayFormField } from '@gogame/form';

import { useCanEditAll } from 'scenes/CustomAudiences/EditGranularityContext';
import { getDefaultValues } from 'scenes/CustomAudiences/PartnerAudiences/components/PartnerAudienceForm/schemas';

import AddPartnerButton from './AddPartnerButton';
import { getComponent } from './Partners';

const FieldSet = ({
  depends = [],
  name: path,
  value = [],
  error,
  push,
  remove,
  editable,
}) => {
  const handleAdd = (partner) => {
    console.log('FieldSet.handleAdd', partner);
    push(getDefaultValues(partner));
  };
  const canEditAll = useCanEditAll();

  return (
    <Section title={'Partner Audiences'} error={!error} subTitle={error}>
      <Grid container spacing={3}>
        {value?.map((row, index) => {
          const partnerComponent = getComponent(row.partner);
          return (
            <Grid item xs={12}>
              {React.createElement(partnerComponent, {
                key: index,
                name: `${path}[${index}]`,
                path: `${path}[${index}]`,
                externalDepends: depends,
                value: row,
                onRemove: () => remove(index),
                disabled: !(editable || canEditAll),
              })}
            </Grid>
          );
        })}
        <Grid item xs={12}>
          <AddPartnerButton
            onClick={handleAdd}
            depends={depends}
            disabled={!(editable || canEditAll)}
          />
        </Grid>
      </Grid>
    </Section>
  );
};

export default withArrayFormField()(FieldSet);
